<template>
  <v-menu
    min-width="350"
    v-model="show"
    bottom
    left
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn color="primary" icon min-width="0" text v-bind="attrs" v-on="on">
        <v-icon>mdi-bell</v-icon>
        <v-badge
          color="primary"
          v-if="listNotifications.length > 0"
          overlap
          bordered
        >
          <template v-slot:badge>
            <span>{{ listNotifications.length }}</span>
          </template>
        </v-badge>
      </v-btn>
    </template>
    <v-list :tile="false" nav v-on:click.stop>
      <v-btn
        style="float: right"
        class="v-btn--icon"
        v-on:click="show = false"
        text
        min-width="0"
      >
        <v-icon color="primary">mdi-close</v-icon>
      </v-btn>
      <div class="chat-list-container">
        <div class="chat-list">
          <div
            v-for="notification in listNotifications"
            :key="notification.id"
            class="row badge-mini-list chat-row"
          >
            <div class="badge-mini-container">
              <img :src="notification.senderFoto" alt="avatar" />
            </div>
            <div class="text">
              <b>{{ notification.title }}</b>
              <br />
              <small>{{ notification.body }}</small>
            </div>
          </div>
        </div>
        <v-flex class="clearNotify justify-center">
          <v-btn color="success" v-on:click="clearNotify">{{
            $t("clear_notify")
          }}</v-btn>
        </v-flex>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "notification-panel",

  props: {
    type: {
      type: String,
      default: "desktop",
    },
    newNotify: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      show: false,
      listNotifications: [],
    };
  },
  methods: {
    clearNotify() {
      this._data.listNotifications = [];
    },
  },
  mounted() {},
  watch: {
    newNotify: function (value) {
      if (value) this._data.listNotifications.push(value);
    },
  },
};
</script>
<style lang="scss" scoped>
.clearNotify {
  margin-top: 10px;
  text-align: center;
}
.chat-list-container {
  height: 260px;
  overflow: hidden;
}

.chat-list {
  height: 200px;
  padding: 0px;
  overflow-y: auto;
  overflow-x: hidden;
}
.chat-row {
  position: relative;
}
.badge-mini-container {
  position: relative;
  left: 10px;
  width: 50px;
  height: 50px;
  img {
    width: 30px;
    height: 30px;
    border-radius: 30px;
    margin: 10px;
  }
}
.text {
  position: absolute;
  right: 0px;
  width: calc(100% - 60px);
  top: 5px;
  line-height: 20px;
}
</style>
